import React, { Component } from "react"
import {
  Dialog,
  Typography,
  DialogTitle,
  DialogContent,
  Divider,
  DialogActions,
  IconButton,
  Icon,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Checkbox,
  Button,
} from "@material-ui/core"
import { withStyles } from "@material-ui/styles"
import styles from "./styles"

class CreatorFilterDialog extends Component {
  state = {
    checked: [],
    and: false,
    filterOptions: [],
  }

  componentDidMount() {
    const { creators } = this.props
    this.setState({
      filterOptions: creators.map(creator => {
        return {
          ...creator,
          type: "creator",
          name: `${creator.first_name} ${creator.last_name}`,
          func: shoot => shoot.creator_id === creator.id,
        }
      }),
    })
  }

  componentDidUpdate(p) {
    if (!p.open && this.props.open) {
      const checked = this.props.creatorFilters.map(x =>
        this.props.creators.findIndex(
          y => y.first_name + " " + y.last_name === x
        )
      )
      this.setState({ checked })
    }
  }

  onChange = data => {
    this.props.onChange(data, this.state.and)
  }

  closeDialog = () => {
    this.props.onClose()
    setTimeout(() => {
      this.setState({ checked: [] })
    }, 300)
  }

  render() {
    const { props, state, onChange } = this
    const { open, onClose, onClear, classes } = props
    const { checked, filterOptions } = state
    return (
      <Dialog onClose={this.closeDialog} open={open}>
        <DialogTitle className={classes.dialogTitle}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Typography style={{ fontWeight: "bold", color: "white" }}>
              Booked By:
            </Typography>
            <div style={{ flexGrow: 1 }} />
            <IconButton onClick={onClose}>
              <Icon style={{ color: "white" }}>close</Icon>
            </IconButton>
          </div>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <List component="nav">
            {filterOptions.map((x, i) => {
              return (
                <ListItem
                  style={{ marginRight: "128px" }}
                  key={i}
                  button
                  disableRipple
                  onClick={e => {
                    if (checked.indexOf(i) >= 0) {
                      this.setState({
                        checked: checked.filter(x => x !== i),
                      })
                    } else {
                      this.setState({ checked: checked.concat([i]) })
                    }
                  }}
                >
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      checked={checked.indexOf(i) >= 0}
                      disableRipple
                      color="primary"
                    />
                  </ListItemIcon>
                  <ListItemText primary={x.name} secondary={x.description} />
                </ListItem>
              )
            })}
          </List>
        </DialogContent>
        <DialogActions>
          <div style={{ flexGrow: 1 }} />
          <Button
            variant="text"
            color="primary"
            onClick={e => {
              onClear()
              this.closeDialog()
            }}
          >
            Clear Filters
          </Button>
          <Button
            onClick={e => {
              onChange(filterOptions.filter((x, i) => checked.indexOf(i) >= 0))
              this.closeDialog()
            }}
            variant="contained"
            color="primary"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default withStyles(styles)(CreatorFilterDialog)
